import PropTypes from "prop-types";
import { useState } from "react";
import { FormField, Radio } from "semantic-ui-react";

const SuiRadioButtonGroup = ({ disabled, isVertical, required, groupLabel, name, options, value }) => {
  const defaultRadioOption = value ?? options?.find((radio) => radio.default)?.value;

  const [selectedRadio, setSelectedRadio] = useState(defaultRadioOption);

  const handleChange = (e, radio) => {
    setSelectedRadio(radio.value);
    if (radio.onChange) {
      radio.name = name;
      radio.onChange(e, radio);
    }
  };

  if (!options?.length) return null;

  return (
    <FormField
      inline
      required={required}
    >
      {groupLabel && <label>{groupLabel}</label>}

      <div style={{ display: "inline-block" }}>
        {options.map((radio, i) => (
          <Radio
            key={`radio-${name}-${radio.value}`}
            style={
              isVertical
                ? { display: "block", marginTop: i > 0 ? "8px" : 0 }
                : i > 0
                  ? { marginLeft: "15px" }
                  : undefined
            }
            checked={selectedRadio === radio.value}
            data-testid={`${name}-input-${radio.value}`}
            disabled={disabled}
            label={radio.label}
            name={name}
            onChange={(e) => handleChange(e, radio)}
            value={radio.value}
          />
        ))}
      </div>
    </FormField>
  );
};

SuiRadioButtonGroup.propTypes = {
  groupLabel: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  disabled: PropTypes.bool,
  isVertical: PropTypes.bool,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      onChange: PropTypes.func,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      default: PropTypes.bool,
    }),
  ).isRequired,
  name: PropTypes.string.isRequired,
  required: PropTypes.bool,
};

export default SuiRadioButtonGroup;
